$(function() {
  const newsletterConfirmationModalEl = document.querySelector('.newsletter-confirmation-modal');
  if (newsletterConfirmationModalEl) {
    triggerAndSetupNewsletterModal(newsletterConfirmationModalEl)
  }
})
